import UserRolesEnum from '../enums/UserRolesEnum'
import AuthService from 'services/AuthService'

export default {
    methods: {
        completePhysicianRegistration(isRegistrationCompleted) {
            if (isRegistrationCompleted) {
                AuthService.setLastRegisteredPhysician(AuthService.getActiveMember())
            }
        },
    },

    computed: {
        isAdminRegisteringPhysician() {
            return this.$auth.getUser().userRole?.id === UserRolesEnum.OFFICE_MANAGER.ID && this.$auth.isActiveMemberPhysician()
        },
    },
}
